// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"d9324f6d","54":"96d99433","271":"64520350","318":"ef6b04e6","340":"68d986be","395":"a0f56947","527":"be8c5245","647":"c2311a76","944":"83762a57","953":"2a5bf881"}[chunkId] + ".chunk.js";
};